import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hero", "thumb"]

  preload(event) {
    const url = event.currentTarget.dataset.galleryUrl
    if (url && !this.preloaded?.has(url)) {
      const img = new Image()
      img.src = url
      this.preloaded = this.preloaded || new Set()
      this.preloaded.add(url)
    }
  }

  swap(event) {
    const thumb = event.currentTarget
    const url = thumb.dataset.galleryUrl
    this.heroTarget.src = url
    this.heroTarget.dataset.lightboxIndex = thumb.dataset.lightboxIndex
    this.thumbTargets.forEach(t => t.classList.remove("active"))
    thumb.classList.add("active")
  }
}
